import { dateToApiFormat } from '@/helpers/dateHelper';
import { useGetMeQuery, useGetRosteredStaffInDateRangeQuery } from '../gql/graphql.generated';
import { useMyLocation } from '../useLocations';

const useRosterForDay = (date: Date, userId: string | undefined) => {
  const selectedLocationId = useMyLocation().id;

  const [{ data: rosterData }] = useGetRosteredStaffInDateRangeQuery({
    variables: {
      startDate: dateToApiFormat(date),
      endDate: dateToApiFormat(date),
      locationId: selectedLocationId
    },
    requestPolicy: 'cache-and-network'
  });

  return rosterData?.rosteredStaffInDateRange?.find(s => s.identityId === userId);
};

export const useMyShiftDetailsForDay = (date: Date) => {
  const [{ data: myData }] = useGetMeQuery();
  const userId = myData?.myEmployee?.identityId;

  return useRosterForDay(date, userId);
};

export const useShiftDetailsForDayByUserId = (date: Date, userId: string) => {
  return useRosterForDay(date, userId);
};
